import { useSelector } from 'react-redux';
import { MarkerIcon } from '@rsos/assets/icons';
import { ActionBarItem } from '../ActionBarItem';

const EmergencyCallsActionBarItem = ({ onClick }) => {
  const isCollapsed = useSelector(state => state.queue?.isQueueCollapsed);

  return (
    <ActionBarItem
      shouldRender={isCollapsed}
      tooltipText="911"
      onClick={onClick}
      color="success"
    >
      <MarkerIcon height={16} width={16} />
      911
    </ActionBarItem>
  );
};

export default EmergencyCallsActionBarItem;
